export const contactValidator = [
  {
    path: '/validacao-tipos',
    name: 'patient-validation-contact-types',
    component: () => import('@/views/validationPatient/contactTypes/ContactTypes.view.vue'),
    meta: {
      publicRoute: true,
      header: {
        title: 'Validação de identidade',
      },
      body: {
        contactType: 'sms'
      },
    },
  },
  {
    path: '/selecione-contato',
    name: 'patient-validation-select-contact',
    component: () => import('@/views/validationPatient/selectContact/SelectContact.view.vue'),
    meta: {
      publicRoute: true,
      header: {
        title: 'Confirme seu contato',
      },
    },
  },

  {
    path: '/insira-o-codigo',
    name: 'patient-validation-insert-token',
    component: () => import('@/views/validationPatient/insertToken/InsertToken.view.vue'),
    meta: {
      publicRoute: true,
      header: {
        title: 'Insira o código de validação',
      },
    },
    beforeEnter: (to, from, next) => {
      const hasToken = sessionStorage?.getItem('user');
      hasToken ? next('/') : next();
    }
  },
];
